<template>
  <v-container style="background-color: white; min-height: 700px" class="rounded-lg gradient">
    <v-row>
      <v-col cols="12" md="2">
        <v-banner color="purple" dark shaped height="50px" width="140px">
          <h2>ABOUT</h2>
        </v-banner>
      </v-col>
    </v-row>
    <br>
    <p>The 31th Wireless and Optical Communications Conference (WOCC 2022) is an IEEE
      international conference. For three decades, WOCC has served as a platform for
      researchers and professionals from academia, industry, and government to
      exchange their new findings and the latest developments in research areas ranging
      from wireless and optical communications, networking to big data.</p>
  </v-container>
</template>

<script>
export default {
  name: "About"
}
</script>

<style scoped>
</style>
